import { TockCookieName } from '../constants/browser-storage/TockCookies';
import { appendCookieSuffixes, getCookie, setCookie } from './cookieUtils';
import env from './env';

/**
 *  Auth (TockCookieName.ACCESS) domain-specific cookie functions
 */
export function getAuthCookie(domain: string) {
  return getCookieForDomain(TockCookieName.ACCESS, domain);
}

export function setAuthCookie(domain: string, cookieValue: string, expiration: number) {
  seCookieForDomain(TockCookieName.ACCESS, domain, cookieValue, expiration);
}

export function clearAuthCookie(domain: string) {
  clearCookieForDomain(TockCookieName.ACCESS, domain);
}

export function getAuthCookieName(domain: string) {
  return getCookieNameForDomain(TockCookieName.ACCESS, domain);
}

/**
 * Generic domain-specific cookie functions
 */
export function getCookieForDomain(name: TockCookieName, domain: string) {
  return getCookie(getCookieNameForDomain(name, domain));
}

export function seCookieForDomain(
  name: TockCookieName,
  domain: string,
  cookieValue: string,
  expiration: number
) {
  setCookie(name, cookieValue, {
    expirationFromNow: expiration,
    suffixOptions: {
      envSuffix: env.get(domain),
    },
  });
}

export function clearCookieForDomain(name: TockCookieName, domain: string) {
  setCookie(name, null, {
    suffixOptions: {
      envSuffix: env.get(domain),
    },
  });
}

export function getCookieNameForDomain(name: TockCookieName, domain: string) {
  const environmentName = env.get(domain);
  return appendCookieSuffixes(name, { envSuffix: environmentName });
}
